import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { get_legal_links } from './get_legal_links';
/**
 * Renders the update Fitness legal links (Impressum + Datenschutz) for the
 * given language. Presentational and styling-agnostic so every app can reuse
 * it while keeping the underlying URLs and labels in one shared place.
 *
 * @param props - See {@link LegalLinksProps}.
 * @returns The legal-links navigation element.
 */
export function LegalLinks({ language, on_navigate, className, link_class_name, style, link_style, separator, aria_label, }) {
    const links = get_legal_links(language);
    return (_jsx("nav", { className: className, style: style, "aria-label": aria_label ?? 'Legal', children: links.map((link, index) => (_jsxs(Fragment, { children: [index > 0 && separator !== undefined ? separator : null, on_navigate !== undefined ? (_jsx("button", { type: "button", className: link_class_name, style: link_style, onClick: () => on_navigate(link), children: link.label })) : (_jsx("a", { className: link_class_name, style: link_style, href: link.url, target: "_blank", rel: "noopener noreferrer", children: link.label }))] }, link.kind))) }));
}
//# sourceMappingURL=legal_links.js.map